
const PLURALS = {
    "Day": "Days",
    "Stage": "Stages",
    "Action": "Actions",
    "Space Type": "Space Types",
    "State": "States",
    "Property": "Properties",
    "Match": "Matches",
    "Contact": "Contacts",
    "has": "have",
};

export default PLURALS;